import { AutoRoutes } from "./auto";
import { cartRoutes } from "./cart";
import { healthRoutes } from "./health";
import { notFoundRoute } from "./notFound";
import { paymentRoutes } from "./payment";
import { personalAccidentRoutes } from "./personalAccident";
import { lifeRoutes } from "./life";
import { houseHoldRoutes } from "./houseHold";
import { travelRoutes } from "./travel";
import { vfsRoutes } from "./vfs";
import { blogRoutes } from "./blogs";
import { deleteAccountRoute } from "./deleteAccount";

export const PublicRoutes = [
  ...deleteAccountRoute,
  ...healthRoutes,
  ...cartRoutes,
  ...paymentRoutes,
  ...notFoundRoute,
  ...AutoRoutes,
  ...personalAccidentRoutes,
  ...houseHoldRoutes,
  ...lifeRoutes,
  ...travelRoutes,
  ...blogRoutes,
  ...vfsRoutes
];
